import styled,{ keyframes } from 'styled-components';
import { MdKeyboardArrowRight, MdArrowForward } from 'react-icons/md';

const anim2 = keyframes`
    from{
            left: -100%;
        }
        to{
            left:0%;
        }
`;

const animateWave = keyframes`
    0% {
      transform: scale(1,0);
    }
    100% {
      transform: scale(1,1);
    }
`

export const LandingContainer = styled.div`

    justify-content: center;
    align-items: center;
    height: 100vh;
    position: relative;
    z-index: 2;

    // :before{
    //     content: '';
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     right: 0;
    //     bottom: 0;
        
    //     z-index: 2;

    // }

    //  @media screen and (max-width: 991px){
    //     width: ${({isLandscape}) => (isLandscape ? '132vw' : '100%')};
    //     height: ${({fixLandscape}) => (fixLandscape ? '100vw;' : '100vh')};
    //  }

    // @media screen and (max-width: 480px){
    //         height: 105vh;
    // }
` 

export const WaveContainer = styled.div`
    position: relative;
    background: rgba(0,0,0,0.3);
   //background: linear-gradient(to right, rgba(38,61,250,0.3) 0%, rgba(54,104,244,0.3) 14%, rgba(70,153,236,0.3) 35%, rgba(83,188,232,0.3) 56%, rgba(83,200,236,0.3) 77%, rgba(78,235,248,0.3) 100%);
    color: white;
    text-align: right;
    overflow: hidden;
    height: 100vh;
   width: 100%;
    // @media screen and (max-width: 1366px){
    //     height: 625px;
    // }
    
    // @media screen and (max-width: 480px){
    //     height: 100vh;
    // }
`
export const Wave = styled.svg`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    animation: ${anim2} 2s forwards 0s;
    
    @media screen and (max-width: 480px){
        bottom: 0;
    }

`

export const Logo = styled.img.attrs(props => ({src: props.image}))`
       width: 15rem;       
       transition: .3s ease-in-out 0s;
     
       
   
       @media screen and (max-width: 1400px){
        width: 8rem;
       }

    @media screen and (max-width: 768px){
       
    }

    @media screen and (max-width: 380px){
        width: 5rem;

    }
`


export const LandingContentWrapper = styled.div`
    display: flex;
    animation: ${anim2} 2s forwards 0s;
    justify-content: flex-end;
    //height: 370px;
    width: 55%;
    background: rgba(8,50,66,0.3);
   // background: rgba(134,115,46,0.3);
//    background: rgba(189,179,169,0.3);
// background: rgba(255,255,255,.5);
    height: 100vh;
     @media screen and (max-width: 1400px){
        width: 5rem;
width: 100%;        
    }
    
`

export const LandingContent = styled.div`
padding-right: 100px;
    width: 50%;
    padding-top:100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    animation: ${anim2} 2s forwards 0s;

        @media screen and (max-width: 1400px){
        width: 100%;
        padding-right: 0;
        
        
            }
            


    @media screen and (max-width: 480px){
     padding-top:0px;
        padding: 30px;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        display: flex;
        max-width: 1020px;
        margin: 0 auto;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        animation: ${anim2} 2s forwards 0s;
        height: 100vh;
    }

`   

export const LandingBg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
`

export const VideoBg = styled.video`
    width: 100%;
    height:100vh;
    -o-object-fit: cover;
    object-fit: cover;
    object-position: bottom;
    background: #232a34;
    // @media screen and (max-width: 1366px){
    //     height: 625px;
    // }
    
    // @media screen and (max-width: 480px){
    //     height: 100vh;
    // }
    
`

export const LandingH1 = styled.h1`
    font-size: 36px;
    max-width: 440px;
    color: #FFF;
    text-align: center;
    font-weight: 700;
    font-family: 'Roboto-regular', sans-serif;     
    margin-bottom: 40px;

     @media screen and (max-width: 1366px){
       font-size: 30px;
       margin-bottom: 10px;
       }

   
    @media screen and (max-width: 480px){
        margin-top: 100px;
        font-size: 26px;
        text-align: center;
         margin-bottom: 20px;
    }

`


export const LandingP = styled.p`
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 1.2em;
    max-width: 350px;
    font-weight: 450;
    color: #FFF;
    text-align: center;
    font-family: 'Barlow Condensed', sans-serif;     
    margin-bottom: 20px;


    @media screen and (max-width: 1400px){
        font-size: 1em;
    }

    @media screen and (max-width: 480px){
        display: none;
    }
    
`

export const LandingP2 = styled.p`
    display: none;
    margin-top: 15px;
    color: #fff;
    font-size: 24px;
    max-width: 600px;
    text-shadow: 1px 1px 1px #000;


    @media screen and (max-width: 768px){
        text-align: center;
        display: flex;
        font-size: 24px;
    }
    @media screen and (max-width: 480px){
        font-size: 18px;
    }
`

export const LandingBtnWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-top: 0px;
    padding-left: 0px;
    z-index: 999;
    
    @media screen and (max-width: 480px){
        margin-top: 50px;
        padding-left: 0;
        justify-content: center;
        width: 100%;
    }
`

export const ArrowFoward = styled(MdArrowForward)`
    margin-left: 8px;
    font-size: 20px;
`

export const ArrowRight = styled(MdKeyboardArrowRight)`
    margin-left: 8px;
    font-size: 20px;
`